export enum FileType {
  PDF = 'pdf',
  HTML = 'html',
}

export enum DocumentCategory {
  TRANSCRIPT = 'transcript',
  FILING = 'filing',
  LETTER = 'letter',
  PRESENTATION = 'presentation',
}

export enum TranscriptType {
  EARNINGS_CALL = 'earnings_call',
  SPECIAL = 'special',
}

export enum PresentationType {
  INVESTOR = 'investor',
}

export enum FilingType {
  TEN_K = '10-k',
  TWENTY_F = '20-f',
  TEN_Q = '10-q',
  EIGHT_K = '8-k',
  SIX_K = '6-k',
  EXHIBIT = 'exhibit',
  EARNINGS_RELEASE = 'earnings-release',
}

export enum LetterType {
  SHAREHOLDER_LETTER = 'shareholder_letter',
}

export type DocumentType = TranscriptType | FilingType | LetterType | PresentationType;

export interface DocumentState {
  url: string | null;
  documentId: string | null;
  pageId: string | null;
  textToHighlight: string | null;
}

export interface Document {
  id: string;
  name: string;
  category: DocumentCategory;
  type: DocumentType;
  link: string;
  /**
   * Date string in YYYY-MM-DD format (Postgres DATE)
   */
  published_at?: string | null;
  company_id: string;
  created_at?: string;
  updated_at?: string;
  file_type: FileType;
  fiscal_year: number;
  fiscal_quarter: number | null;
  metadata?: Record<string, any>;
  embedding_count?: number | null;
}
